import { render, staticRenderFns } from "./StateCard.vue?vue&type=template&id=20f5a857&scoped=true&"
import script from "./StateCard.vue?vue&type=script&lang=js&"
export * from "./StateCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f5a857",
  null
  
)

export default component.exports